/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EligibilityStcModel } from './EligibilityStcModel';
import {
    EligibilityStcModelFromJSON,
    EligibilityStcModelFromJSONTyped,
    EligibilityStcModelToJSON,
} from './EligibilityStcModel';
import type { PayerSearchOptionsPayerRequiredFieldsInner } from './PayerSearchOptionsPayerRequiredFieldsInner';
import {
    PayerSearchOptionsPayerRequiredFieldsInnerFromJSON,
    PayerSearchOptionsPayerRequiredFieldsInnerFromJSONTyped,
    PayerSearchOptionsPayerRequiredFieldsInnerToJSON,
} from './PayerSearchOptionsPayerRequiredFieldsInner';

/**
 * 
 * @export
 * @interface PayerSearchOptions
 */
export interface PayerSearchOptions {
    /**
     * Number of days ahead service dates can be searched
     * @type {number}
     * @memberof PayerSearchOptions
     */
    service_date_days_ahead?: number;
    /**
     * Number of days back service dates can be searched
     * @type {number}
     * @memberof PayerSearchOptions
     */
    service_date_days_back?: number;
    /**
     * Number of months ahead service dates can be searched
     * @type {number}
     * @memberof PayerSearchOptions
     */
    service_date_months_ahead?: number;
    /**
     * Number of months back service dates can be searched
     * @type {number}
     * @memberof PayerSearchOptions
     */
    service_date_months_back?: number;
    /**
     * Whether service date ranges are supported
     * @type {boolean}
     * @memberof PayerSearchOptions
     */
    is_service_date_ranged?: boolean;
    /**
     * 
     * @type {Array<EligibilityStcModel>}
     * @memberof PayerSearchOptions
     */
    eligibility_stc_models?: Array<EligibilityStcModel>;
    /**
     * 
     * @type {Array<PayerSearchOptionsPayerRequiredFieldsInner>}
     * @memberof PayerSearchOptions
     */
    payer_required_fields?: Array<PayerSearchOptionsPayerRequiredFieldsInner>;
    /**
     * Maximum number of service type codes allowed
     * @type {number}
     * @memberof PayerSearchOptions
     */
    max_stcs?: number;
    /**
     * ID of the payer type
     * @type {number}
     * @memberof PayerSearchOptions
     */
    payer_type_id?: number;
}

/**
 * Check if a given object implements the PayerSearchOptions interface.
 */
export function instanceOfPayerSearchOptions(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PayerSearchOptionsFromJSON(json: any): PayerSearchOptions {
    return PayerSearchOptionsFromJSONTyped(json, false);
}

export function PayerSearchOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): PayerSearchOptions {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'service_date_days_ahead': !exists(json, 'service_date_days_ahead') ? undefined : json['service_date_days_ahead'],
        'service_date_days_back': !exists(json, 'service_date_days_back') ? undefined : json['service_date_days_back'],
        'service_date_months_ahead': !exists(json, 'service_date_months_ahead') ? undefined : json['service_date_months_ahead'],
        'service_date_months_back': !exists(json, 'service_date_months_back') ? undefined : json['service_date_months_back'],
        'is_service_date_ranged': !exists(json, 'is_service_date_ranged') ? undefined : json['is_service_date_ranged'],
        'eligibility_stc_models': !exists(json, 'eligibility_stc_models') ? undefined : ((json['eligibility_stc_models'] as Array<any>).map(EligibilityStcModelFromJSON)),
        'payer_required_fields': !exists(json, 'payer_required_fields') ? undefined : ((json['payer_required_fields'] as Array<any>).map(PayerSearchOptionsPayerRequiredFieldsInnerFromJSON)),
        'max_stcs': !exists(json, 'max_stcs') ? undefined : json['max_stcs'],
        'payer_type_id': !exists(json, 'payer_type_id') ? undefined : json['payer_type_id'],
    };
}

export function PayerSearchOptionsToJSON(value?: PayerSearchOptions | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'service_date_days_ahead': value.service_date_days_ahead,
        'service_date_days_back': value.service_date_days_back,
        'service_date_months_ahead': value.service_date_months_ahead,
        'service_date_months_back': value.service_date_months_back,
        'is_service_date_ranged': value.is_service_date_ranged,
        'eligibility_stc_models': value.eligibility_stc_models === undefined ? undefined : ((value.eligibility_stc_models as Array<any>).map(EligibilityStcModelToJSON)),
        'payer_required_fields': value.payer_required_fields === undefined ? undefined : ((value.payer_required_fields as Array<any>).map(PayerSearchOptionsPayerRequiredFieldsInnerToJSON)),
        'max_stcs': value.max_stcs,
        'payer_type_id': value.payer_type_id,
    };
}

